import { Component, computed, inject, signal } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { PageHeader } from '../../../shared/page-header/page-header';

/**
 * Mostra os endereços do portal público da empresa. Sem esta página o portal existia mas ninguém
 * dentro da aplicação sabia que endereço divulgar no site.
 */
@Component({
  selector: 'app-public-portal',
  imports: [PageHeader],
  templateUrl: './public-portal.html',
})
export class PublicPortal {
  private readonly auth = inject(AuthService);

  protected readonly copied = signal<string | null>(null);

  private readonly origin = location.origin;
  protected readonly tenant = computed(() => this.auth.currentTenant() ?? '');

  protected readonly submitUrl = computed(() => `${this.origin}/${this.tenant()}/participar`);
  protected readonly trackUrl = computed(() => `${this.origin}/${this.tenant()}/acompanhar`);

  protected async copy(url: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(url);
      this.copied.set(url);
      setTimeout(() => this.copied.set(null), 2500);
    } catch {
      this.copied.set(null);
    }
  }

  protected open(url: string): void {
    window.open(url, '_blank', 'noopener');
  }
}
